export default {"src":"/_next/static/media/enroll_icon.a9bd8b0e.svg","height":284,"width":284};